import React from 'react';
import { TextButton } from '@oneaudi/unified-web-components';
import type { VendorCtaSelectorProps } from './VendorCtaSelector';

const VinRecallCta = ({ ctaDetails, variant, vin, vehicleType }: VendorCtaSelectorProps) => {
  // This CTA should be enabled ONLY for pre-owned Vehicles (both Audi and Non Audi)
  if (vehicleType === 'new') return null;
  return (
    <TextButton
      className="vin-recall-cta"
      variant={variant}
      href={`https://vinrcl.safercar.gov/vin/?vin=${vin}`}
      data-testid="vinRecallCta"
      target="_blank"
      rel="noopener noreferrer"
    >
      {ctaDetails?.vinRecallLabel ?? 'NHTSA VIN Look up'}
    </TextButton>
  );
};

export default VinRecallCta;
